var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDurationIcon = function SvgDurationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12 3.4c-4.7 0-8.6 3.8-8.6 8.6 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-4.7-3.9-8.6-8.6-8.6M17 15c-.2.3-.5.5-.8.5-.2 0-.3 0-.5-.1L11.5 13c-.3-.2-.5-.6-.5-1V5.7c0-.5.4-1 1-1s1 .4 1 1v5.8l3.7 2.1c.4.3.6.9.3 1.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12S6.2 22.5 12 22.5 22.5 17.8 22.5 12 17.8 1.5 12 1.5m0 19.1c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.8 8.6 8.6c0 4.7-3.9 8.6-8.6 8.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.7 13.7 13 11.5V5.7c0-.5-.4-1-1-1s-1 .4-1 1V12c0 .4.1.7.5.9l4.2 2.4c.2.1.3.1.5.1.3 0 .7-.2.8-.5.3-.4.1-1-.3-1.2"
  })));
};
export default SvgDurationIcon;